'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

require('../../src/styles/external.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns the styles class name based on the profile type.
 * @param {string} profileType The profile type: practice or specialist.
 * @return {!Object} The styles class name.
 */

// import messages from '../lang/default-messages';

// import { FormattedMessage } from 'react-intl';

var getProfileTypeClassName = function getProfileTypeClassName(profileType) {
	return profileType.toLowerCase() === 'practice' && _style2.default.practice || profileType.toLowerCase() === 'specialist' && _style2.default.specialist;
};

/**
 * Returns the active tab. If no active tab is specified in props, the first
 * tab is selected by default.
 * @param {!Array<string>} tabs The tabs.
 * @param {string} activeTab The active tab.
 * @return {string} The active tab, or default active tab if none is specified.
 */
var getActiveTab = function getActiveTab(tabs, activeTab) {
	return activeTab || tabs.length > 0 && tabs[0];
};

var HeaderTabs = function HeaderTabs(props) {
	return props.tabs.length > 0 && _react2.default.createElement(
		'div',
		{ className: _style2.default.tabsContainer + ' ' + props.className },
		props.tabs.map(function (tab, index) {
			return _react2.default.createElement(
				'div',
				{ key: index,
					className: _style2.default.tab + ' ' + getProfileTypeClassName(props.profileType) + ' ' + (tab === getActiveTab(props.tabs, props.activeTab) ? _style2.default.active : ''),
					style: { minWidth: 'calc(100% / ' + props.tabs.length + ')' },
					onClick: function onClick() {
						return props.onTabSelected(tab);
					} },
				tab
			);
		})
	);
};

HeaderTabs.propTypes = {
	tabs: require('react').PropTypes.arrayOf(require('react').PropTypes.any).isRequired,
	activeTab: require('react').PropTypes.any.isRequired,
	profileType: require('react').PropTypes.any.isRequired,
	className: require('react').PropTypes.any.isRequired,
	onTabSelected: require('react').PropTypes.func.isRequired
};
HeaderTabs.displayName = 'HeaderTabs';

HeaderTabs.defaultProps = {
	tabs: [],
	activeTabIndex: '',
	profileType: 'specialist',
	onTabSelected: function onTabSelected() {}
};

exports.default = HeaderTabs;